'use client';

import { useAppContext } from '@ifixit/app/hooks';
import { useMemo } from 'react';
import { IFixitAPIClient } from '.';

export function useBaseIFixitApiClient({ disableCacheGets }: { disableCacheGets: boolean }) {
   const { ifixitOrigin } = useAppContext();

   const client = useMemo(
      () =>
         new IFixitAPIClient({
            disableCacheGets,
            origin: ifixitOrigin,
         }),
      [disableCacheGets, ifixitOrigin]
   );

   return client;
}

export function useIFixitApiClient() {
   const search = typeof window === 'undefined' ? '' : window.location.search;
   const disableCacheGets = new URLSearchParams(search).has('disableCacheGets');
   return useBaseIFixitApiClient({ disableCacheGets });
}
